import { useSyncExternalStore } from 'react';

/**
 * Sunum modu (22 Ekim 2026; SellerFlash'taki "Sunum modu"). Ekran paylaşırken ya da ekran
 * görüntüsü alırken kâr, maliyet, ciro ve müşteri bilgileri bulanıklaşıyor.
 *
 * Gizlenecek değeri taşıyan öğeye `hassas` sınıfı veriliyor; açıkken `<html data-sunum>`
 * ve `globals.css`'teki kural onları bulanıklaştırıyor. Seçim bu tarayıcıda kalıyor
 * (localStorage) — sunucuya gitmiyor, başka kullanıcıyı etkilemiyor.
 */

const ANAHTAR = 'amzjp-sunum';
const OLAY = 'amzjp-sunum-degisti';
const PANEL_PARAMETRESI = 'sunum';

export function sunumModuAcikMi(): boolean {
  return document.documentElement.hasAttribute('data-sunum');
}

export function sunumModunuAyarla(acik: boolean): void {
  document.documentElement.toggleAttribute('data-sunum', acik);
  try {
    if (acik) localStorage.setItem(ANAHTAR, '1');
    else localStorage.removeItem(ANAHTAR);
  } catch {
    // Gizli sekmede yazılamayabilir — mod yine de bu sayfada uygulanır
  }
  window.dispatchEvent(new Event(OLAY));
}

function kayitliMi(): boolean {
  try {
    return localStorage.getItem(ANAHTAR) === '1';
  } catch {
    return false; // depolama kapalı — mod kapalı başlar
  }
}

/**
 * Açılışta bir kez: önceki oturumda açık bırakıldıysa ya da başka panelden açık gelindiyse açık
 * başlar. Sonra başka sekmedeki değişikliği de izler: paylaşım sırasında diğer sekmeye geçilince
 * orada kâr açıkta kalıyordu.
 */
export function sunumModunuYukle(): void {
  const adres = new URL(window.location.href);
  if (adres.searchParams.get(PANEL_PARAMETRESI) === '1') {
    adres.searchParams.delete(PANEL_PARAMETRESI);
    window.history.replaceState(window.history.state, '', adres);
    sunumModunuAyarla(true);
  } else if (kayitliMi()) {
    document.documentElement.setAttribute('data-sunum', '');
  }

  window.addEventListener('storage', (e) => {
    if (e.key !== ANAHTAR && e.key !== null) return;
    document.documentElement.toggleAttribute('data-sunum', kayitliMi());
    window.dispatchEvent(new Event(OLAY));
  });
}

/**
 * "Başka panele geç" bağlantısı. Paneller ayrı alan adında, seçim localStorage'da: mod açıkken
 * başka panele geçince orada kapalı açılıyor ve kâr görünüyordu.
 */
export function panelAdresi(adres: string, sunumAcik: boolean): string {
  return sunumAcik ? `${adres}/?${PANEL_PARAMETRESI}=1` : adres;
}

export function sunumModuDinle(dinleyici: () => void): () => void {
  window.addEventListener(OLAY, dinleyici);
  return () => window.removeEventListener(OLAY, dinleyici);
}

/** Bulanıklık yetmeyen yerler için (tarayıcı ipucu `title` bulanıklaşmıyor). */
export function useSunumModu(): boolean {
  return useSyncExternalStore(sunumModuDinle, sunumModuAcikMi, () => false);
}
